import { useHashRoute, Link, navigate } from "../router";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { LANGS, LANG_LABEL } from "../i18n";
import { BACKEND_ENABLED } from "../config";

function toggleTheme() {
  const isDark = document.documentElement.classList.toggle("dark-mode");
  localStorage.setItem("survantic_support_theme", isDark ? "dark" : "light");
}

export function Header() {
  const route = useHashRoute();
  const { session, logout } = useAuth();
  const { lang, setLang, t } = useLang();
  const top = route.segments[0] ?? "";

  const nav: { to: string; label: string; key: string }[] = [
    { to: "/docs", label: t.nav.docs, key: "docs" },
    { to: "/faq", label: t.nav.faq, key: "faq" },
    ...(BACKEND_ENABLED
      ? [{ to: "/downloads", label: t.nav.downloads, key: "downloads" }]
      : []),
  ];

  return (
    <header className="app-header">
      <div className="app-header-inner">
        <Link to="/" className="brand">
          <span className="brand-mark" aria-hidden="true" />
          <span className="brand-name">
            Survantic <span className="brand-sub">{t.brandSub}</span>
          </span>
        </Link>

        <nav className="app-nav">
          {nav.map((n) => (
            <Link
              key={n.key}
              to={n.to}
              className={`nav-link${top === n.key ? " active" : ""}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="app-header-right">
          <div
            className="lang-switch"
            role="group"
            aria-label={t.langSwitchLabel}
          >
            {LANGS.map((l) => (
              <button
                key={l}
                type="button"
                className={`lang-btn${lang === l ? " active" : ""}`}
                aria-pressed={lang === l}
                onClick={() => setLang(l)}
              >
                {LANG_LABEL[l]}
              </button>
            ))}
          </div>
          <button
            className="icon-btn"
            onClick={toggleTheme}
            title={t.themeToggle}
            aria-label={t.themeToggle}
          >
            ◐
          </button>
          {BACKEND_ENABLED &&
            (session ? (
              <div className="user-chip">
                <span className="user-email" title={session.email}>
                  {session.email}
                </span>
                <button className="btn btn-ghost btn-sm" onClick={() => logout()}>
                  {t.signOut}
                </button>
              </div>
            ) : (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => navigate("/login")}
              >
                {t.signIn}
              </button>
            ))}
        </div>
      </div>
    </header>
  );
}
